module.exports = __webpack_public_path__ + "img/sam_3x4.d8f216b4.jpg";